<template>
<div class="weather-information">
	<!-- NOTE: 今後、台風以外も表示する予定 -->
	<!-- 台風一覧 -->
	<aside v-if="typhoonList.length > 0" class="typhoon-information">
		<ul class="typhoon-information__list">
			<li
				v-for="(item, index) in typhoonList"
				:key="`typhoon-${index}`"
				class="typhoon-information__item"
			>
				<a href="javascript:void(0);" @click="onClickInformation($event, item.typhoon_number)"><span>{{ item.text }}</span></a>
			</li>
		</ul>
	</aside>
	<!-- /台風一覧 -->
</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_TYPHOON_LIST } from '@/store/modules/weatherForecast/mutation-types'

export default {
	name: 'WeatherInformation',
	components: {},
	data () {
		return {
			typhoonList: []
		}
	},
	created () {
	},
	computed: {
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('weatherForecast', ['typhoonListData'])
	},
	mounted () {
		// NOTE: お知らせ機能なのでエラー表示やローディングは行わない（台風情報がない場合は何も表示しない）
		// 台風情報リストデータ取得API
		this.SET_TYPHOON_LIST({
			user_id: this.userId,
			user_token: this.userToken
		}).then(res => {
			// console.log(res)
			// NOTE: 発生している台風が無いとき、recordsは空の配列となる
			this.typhoonList = this.typhoonListData.records.map(item => {
				// NOTE: 台風番号は西暦年下2桁＋号数2桁の4桁
				return {
					text: `台風${Number(item.typhoon_number.substr(2, 2))}号が${item.landing_place !== '' ? `${item.landing_place}に` : ''}${item.status}`,
					typhoon_number: item.typhoon_number
				}
			})
			// this.typhoonList = []
		}).catch(error => {
			// NOTE: エラー処理
			console.log('Error: ', error)
		})
	},
	beforeDestroy () {
	},
	methods: {
		// map Vuex actions
		...mapActions('weatherForecast', [SET_TYPHOON_LIST]),

		onClickInformation (e, informationNumber) {
			e.preventDefault()
			this.$emit('setInformationNumber', informationNumber)	// 台風IDを親コンポーネントにemitする
		}
	}
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/variable";

$spacing-3: 0.187rem;
$color-typhoon-tag: #76a5da;

.weather-information {
	font-family: $family-primary;
	padding: $spacing-8 $spacing-4;
	margin: 0 auto $spacing-10;
	background-color: $background-primary;
	line-height: $line-height;
	font-size: $font-size-12;
	text-align: justify;

	&:empty {
		margin: 0;
		padding: 0;
	}
}

// 台風一覧
.typhoon-information {
	&__list {
		list-style: none;
		margin: 0;
		padding: 0;

		li + li { margin-top: $spacing-4;}
	}

	&__item {
		padding: 0 $spacing-6 0 $spacing-3;
		border-radius: 5px;
		border: solid 1px $line-primary;

		& > a {
			display: flex;
			width: 100%;
			text-decoration: none;
			color: $text-bold;

			&::before {
				content: '台風情報';
				display: block;
				width: 57px;
				height: 18px;
				padding: $spacing-4 $spacing-6;
				margin: $spacing-3 0;
				box-sizing: border-box;
				border-radius: 2px;
				background-color: $color-typhoon-tag;
				font-size: $font-size-10;
				color: $text-seconday;
				text-align: center;
				line-height: $line-height-1;
			}

			& > span {
				display: block;
				flex: 1;
				padding: $spacing-3 0 $spacing-3 $spacing-6;
			}
		}
	}
}
</style>
